import styled from "@emotion/styled"
import { css } from "@emotion/react"
import HeroBreadcrumbsLink from "./HeroBreadcrumbsLink"

const dynamicStyles = ({ theme, to }) => css`
  color: ${(!to && theme.palette.common.white) || "#FFFFFFCC"};
`

const HeroScrollBreadcrumbsLink = styled(HeroBreadcrumbsLink)`
  ${dynamicStyles}
`

export default HeroScrollBreadcrumbsLink
